import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ArrayUtil from '../../../../utils/ArrayUtil';

export class ImportLog extends Component {
  render() {
    const { def } = this.props;
    return (
      <div className="panel panel-default mt25">
        <div className="panel-heading">
          <h3>
            <FormattedMessage id="type.error" defaultMessage="Error" />
          </h3>
        </div>
        <div className="panel-body">
          <div className="">
            {def && ArrayUtil.isNotEmpty(def.messages)
              ? def.messages.map((mes, index) => <p key={def.messages}>{`${index + 1}. ${mes}`}</p>)
              : null}
          </div>
        </div>
      </div>
    );
  }
}

ImportLog.propTypes = {
  def: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default ImportLog;
